function translateDocuments(documents) {
    return documents.map((document) => ({
        NomeArquivo: document.nomeArquivo,
        Base64Arquivo: document.base64,
    }));
}

export function createPayloadTitular(dataActiveContract, dataMovimentacaoTitular, dataTitular, documents) {
    const [ddd, cellphone] =
        dataTitular.cellphone && dataTitular.cellphone.unmaskedValue
            ? dataTitular.cellphone.unmaskedValue.replace(/\(|\)/g, '').split(' ')
            : '';

    const payloadTitular = {
        ...dataMovimentacaoTitular,
        codigoMunicipioAtendimento: +dataTitular.countyService.value,
        dataInicioContribuicao: dataTitular.startDate.value,
        numeroContrato: dataActiveContract.numero,
        altura: dataTitular.height.value && +dataTitular.height.value.replaceAll(',', '.'),
        nomeBairro: dataTitular.hood.value,
        codigoEmpresa: +dataTitular.company.value,
        codigoLotacaoTS: dataTitular.capacity.codigoTS,
        codigoPlano: dataTitular.healthPlan.value,
        complementoEndereco: dataTitular.complement.value || '',
        dataAdmissao: dataTitular.admissionDate.value,
        dataInclusao: dataTitular.dateStartPlan.value,
        dataNascimento: dataTitular.birth.value,
        dataLotacao: dataTitular.startCapacity.value,
        enderecoEmail: dataTitular.email.value,
        estadoCivil: dataTitular.civilState.value,
        nacionalidade: dataTitular.nationality.value,
        sexo: dataTitular.gender.value,
        codigoLocalTrabalho: dataTitular.costCenter.value,
        situacaoNaEmpresa: +dataTitular.functionalStatus.value,
        nomeSocial: dataTitular.socialName.value,
        nomeLogradouro: dataTitular.address.value,
        nomeAssociado: dataTitular.fullName.value,
        nomeCidade: dataTitular.city.nome,
        codigoMunicipioResidencia: dataTitular.city.value,
        codigoMunicipio: dataTitular.city.value,
        nomeMae: dataTitular.motherName.value,
        numeroCEP: dataTitular.cep.unmaskedValue,
        numeroCPF: dataTitular.cpf.unmaskedValue,
        dddCelular: ddd,
        numeroDeclaracaoNascidoVivo: dataTitular.dn.value,
        numeroEndereco: dataTitular.addressNumber.value,
        numeroMatriculaNaEmpresa: dataTitular.functionalEnrollment.value,
        numeroPIS: dataTitular.pis.unmaskedValue,
        numeroSequencialMatricula: dataTitular.enrollmentSequence.value,
        numeroCelular: cellphone,
        numeroUnicoSaude: dataTitular.sus && dataTitular.sus.value ? dataTitular.sus.value.replace(/\s/g, '') : '',
        peso: dataTitular.weight.value && +dataTitular.weight.value.replaceAll(',', '.'),
        siglaUF: dataTitular.uf.value,
        tipoAssociado: 'T',
        codigoCargo: dataTitular.occupation.value,
        anexos: dataMovimentacaoTitular.sequencialMovimentacao ? [] : translateDocuments(documents),
        doencasPreExistentes: dataTitular.cid.value,
        codigoGrupoCarencia: dataTitular.lackGroup.value,
        referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
    };

    return payloadTitular;
}

export function createPayloadDependente(
    dataActiveContract,
    flow,
    dataMovimentacaoTitular,
    dataTitular,
    dataDependente,
    documents
) {
    const keysByFlow =
        flow === 'adicionar_titular'
            ? {
                sequencialMovimentacaoTitular: dataMovimentacaoTitular.sequencialMovimentacao,
            }
            : {
                numeroAssociadoOuCarteiraTitular: dataTitular.cardNumber.value,
            };
    const payloadDependente = {
        ...(dataDependente.dataMovimentacao || {}),
        ...keysByFlow,
        numeroContrato: dataActiveContract.numero,
        // codigoEmpresa: dataTitular.company.value,
        codigoPlano: dataDependente.healthPlan.value,
        dataInclusao: dataDependente.dateStartPlan.value,
        numeroCPF: !dataDependente.cpf.isFake && dataDependente.cpf.unmaskedValue,
        numeroSequencialMatricula: dataDependente.enrollmentSequence.value,
        numeroMatriculaNaEmpresa: dataTitular.functionalEnrollment.value,
        nacionalidade: dataDependente.nationality.value,
        nomeSocial: dataDependente.socialName.value,
        nomeAssociado: dataDependente.fullName.value,
        dataNascimento: dataDependente.birth.value,
        sexo: dataDependente.gender.value,
        nomeMae: dataDependente.motherName.value,
        estadoCivil: dataDependente.civilState.value,
        codigoDependencia: dataDependente.kinshipDegree.value,
        dataCasamento: dataDependente.weddingDate.value,
        numeroPIS: dataDependente.pis.unmaskedValue,
        numeroUnicoSaude:
            dataDependente.sus && dataDependente.sus.value ? dataDependente.sus.value.replace(/\s/g, '') : '',
        numeroDeclaracaoNascidoVivo: dataDependente.dn.value,
        tipoAssociado: 'D',
        anexos: dataDependente?.dataMovimentacao?.sequencialMovimentacao ? [] : translateDocuments(documents),
        doencasPreExistentes: dataDependente.cid.value,
        peso: dataDependente.weight.value && +dataDependente.weight.value.replaceAll(',', '.'),
        altura: dataDependente.height.value && parseFloat(`${dataDependente.height.value}`.replaceAll(',', '.')),
        referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
    };

    if (dataTitular.sequencialMovimentacaoTitular && dataTitular.sequencialMovimentacaoTitular.value)
        payloadDependente.sequencialMovimentacaoTitular = dataTitular.sequencialMovimentacaoTitular
            ? dataTitular.sequencialMovimentacaoTitular.value
            : '';
    else
        payloadDependente.numeroAssociadoOuCarteiraTitular = dataTitular.cardNumber ? dataTitular.cardNumber.value : '';

    return payloadDependente;
}
